package nl.staartvin.solarpower.data.model

data class Location(
    val latitude: Double,
    val longitude: Double,
)
